// extracted by mini-css-extract-plugin
export default {"contentTable":"styles_contentTable__HfzrW","headerTable":"styles_headerTable__S1j2e"};